import React, { useEffect, useState } from "react";

import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";
import { errorNotify } from "../../../Services/Notification";
import { datePickerIcon, closeIcon } from "../../../assetData/icons";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";

const MasterLedgerAddForm = ({
  form,
  segmentName,
  addHandler,
  closeHandler,
  tableData,
  isButtonClicked,
}) => {
  const errors = form?.formState.errors;

  const [bgRed, setBgRed] = useState("");

  form?.watch();
  const onSubmit = async (data) => {
    const duplicacyCheck = () => {
      const ledgerName = tableData
        ?.map((item) => item.account_name)
        .includes(data?.account_name);
      const ledgerShortName = tableData
        ?.map((item) => item.account_short_name)
        .includes(data?.account_short_name);
      return { ledgerName, ledgerShortName };
    };

    const { ledgerName, ledgerShortName } = duplicacyCheck();
    if (ledgerName && ledgerShortName) {
      errorNotify(
        "Entered Ledger Name and Ledger Short Name is already present ",
      );
    } else if (ledgerName && !ledgerShortName) {
      errorNotify("Entered Ledger Name is already present ");
    } else if (!ledgerName && ledgerShortName) {
      errorNotify("Entered Ledger Short Name is already present ");
    } else if (!ledgerName && !ledgerShortName) {
      const statusValue = form.getValues("status") === "true";
      const updatedData = { ...data, status: statusValue };
      const res = await addHandler(updatedData);
      if (res) closeHandler();
    }
  };

  const handleCreditDebit = (e) => {
    const elementId = e.target.id;
    setBgRed((prevValue) => (prevValue === elementId ? prevValue : elementId));
    if (elementId === "debit") {
      form?.setValue("credit_debit", "Debit");
    } else {
      // setValue("C");
    }
  };

  const onClose = () => {
    closeHandler();
  };

  const uniqueGroupNames = [
    ...new Set(tableData?.map((item) => item.group_name)),
  ];

  return (
    <>
      <div className="fixed left-1/2 z-50 mx-auto min-h-[300px] w-[98%] max-w-[1000px] -translate-x-1/2 rounded bg-white p-8 max-lg:top-[30%] max-sm:top-[10%] lg:top-1/2 lg:-translate-y-1/2">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">{`Add ${segmentName}`}</h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form?.handleSubmit(onSubmit)}>
          <div className="scrollbar-custom w-full overflow-x-hidden overflow-y-scroll pr-2 max-lg:max-h-[550px] lg:max-h-[400px] ">
            {/* row 1 */}
            <div className="gap-3 sm:flex">
              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">Ledger Name</label>
                <input
                  placeholder="Type here"
                  {...form?.register("account_name")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-[0.65rem] px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.account_name && "border-[1px] border-red-300",
                  )}
                />
              </div>

              <div className={cn("flex w-full flex-col gap-2 max-sm:mt-4")}>
                <label className="text-base text-[#636363]">Short Name</label>
                <input
                  placeholder="Type here"
                  {...form?.register("account_short_name")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-[0.65rem] px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.account_short_name && "border-[1px] border-red-300",
                  )}
                />
              </div>

              <div className={cn("flex w-full flex-col gap-2 max-sm:mt-4")}>
                <label className="text-base text-[#636363]">
                  Account Group{" "}
                </label>
                <select
                  {...form?.register("group_name")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-[0.65rem] px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.group_name && "border-[1px] border-red-300",
                  )}
                >
                  <option value="">Select</option>
                  {uniqueGroupNames.map((groupName, i) => (
                    <option key={i} value={groupName}>
                      {groupName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* row 3 */}
            <div className="items-end gap-3 max-sm:mt-4 sm:mt-8 sm:flex">
              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">Head Name</label>
                <select
                  {...form?.register("head_name")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-[0.65rem] px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.head_name && "border-[1px] border-red-300",
                  )}
                >
                  <option value="">Select</option>
                  <option>CURRENT LIABILITIES</option>
                  <option>CAPITAL</option>
                  <option>INCOME (DIRECT)</option>
                  <option>CURRENT ASSETS</option>
                  <option>EXPENSES (DIRECT)</option>
                  <option>EXPENSES (INDIRECT)</option>
                  <option>INCOME (INDIRECT)</option>
                  <option>INVESTMENTS</option>
                </select>
              </div>

              <div className={cn("flex w-full flex-col gap-2 max-sm:mt-4")}>
                <label className="text-base text-[#636363]">Account Type</label>
                <select
                  {...form?.register("account_type")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-[0.65rem] px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.account_type && "border-[1px] border-red-300",
                  )}
                >
                  <option value="">Select</option>
                  <option value="A">Asset</option>
                  <option value="E">Expense</option>
                  <option value="I">Income</option>
                  <option value="L">Liability</option>
                </select>
              </div>

              <div
                className={cn("flex w-full flex-col gap-2 max-sm:mt-4")}
                onClick={(e) => handleCreditDebit(e)}
              >
                <label className="text-base text-[#636363]">
                  Credit / Debit
                </label>
                <div
                  className={cn(
                    " flex h-full gap-12 rounded bg-neutral-100 p-[10px] px-2 text-[#636363] placeholder:italic focus:outline-none",
                    "border-[1px]",
                  )}
                >
                  <div className="flex gap-3">
                    <div
                      className={
                        "relative h-[18px] w-[18px] rounded-[50%] border border-[red] bg-neutral-100 py-1 text-[#636363] placeholder:italic focus:outline-none"
                      }
                    >
                      <div
                        className={cn(
                          "absolute ml-[2px] mt-[-2px]  h-[12px] w-[12px] rounded-[50%] border border-[red]  text-[#636363] placeholder:italic focus:outline-none",
                          {
                            "bg-red-500": bgRed === "credit",
                          },
                        )}
                      ></div>
                      <input
                        {...form?.register("credit_debit")}
                        id="credit"
                        class="relative  float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-red-500 opacity-0 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-red-500 checked:bg-red-500 checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-red-500 dark:checked:bg-red-500 dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                        type="checkbox"
                        value="C"
                      />
                    </div>
                    <span className="mt-[-5px]">Credit</span>
                  </div>
                  <div className="flex gap-3">
                    <div
                      className={
                        "relative h-[18px] w-[18px] rounded-[50%] border border-[red] bg-neutral-100 py-1 text-[#636363] placeholder:italic focus:outline-none"
                      }
                    >
                      <div
                        className={cn(
                          `
                      absolute ml-[2.6px] mt-[-2px]  h-[12px] w-[12px] rounded-[50%] border border-[red] text-[#636363] placeholder:italic focus:outline-none`,
                          {
                            "bg-red-500": bgRed === "debit",
                          },
                        )}
                      ></div>
                      <input
                        id="debit"
                        class="relative  float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-red-500 opacity-0 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-red-500 checked:bg-red-500 checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-red-500 dark:checked:bg-red-500 dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                        type="checkbox"
                        value="Debit"
                      />
                    </div>
                    <span className="mt-[-5px]">Debit</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* actions */}
          <div className="flex items-end gap-2 max-sm:justify-center md:justify-between max-sm:[&>button]:w-full sm:[&>button]:w-1/3">
            <button
              type="submit"
              disabled={isButtonClicked}
              className={` ${
                isButtonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-16 py-2 font-semibold text-white `}
            >
              {isButtonClicked ? <MirageLoader /> : "ADD"}
            </button>
            <button className="max-lg:hidden"></button>
            <button className="max-lg:hidden"></button>
          </div>
        </form>
      </div>
      <BackDrop />
    </>
  );
};

export default MasterLedgerAddForm;
